import React, { Component, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { observer } from 'mobx-react';

import { ROUTES } from 'routes/routes';

import Spinner from 'components/Spinner/Spinner';
import NavigationTabs, {
  NavigationTab,
} from 'components/NavigationTabs/NavigationTabs';

import style from './SettingsPage.module.scss';
import RootStore from 'stores/RootStore';

const Staff = React.lazy(() => import('./Staff/Staff'));
const ConfigManagement = React.lazy(() => import('./Config/ConfigManagement'));
const StartScreenDesigner = React.lazy(() =>
  import('./StartScreenDesigner/StartScreenDesigner'),
);
const Banners = React.lazy(() => import('./Banners/Banners'));

@observer
class SettingsPage extends Component {
  render() {
    return (
      <div className={style.content__tabs}>
        <NavigationTabs className={style.tabs} tabs={this.tabs} />

        <Suspense fallback={<Spinner contain />}>
          <Switch>
            <Route path={ROUTES.admin.settings} component={Staff} exact />
            <Route path={ROUTES.admin.config} component={ConfigManagement} />
            <Route
              path={ROUTES.admin.startScreenDesigner}
              component={StartScreenDesigner}
            />
            <Route path={ROUTES.admin.banners} component={Banners} />
          </Switch>
        </Suspense>
      </div>
    );
  }

  get tabs() {
    const tabs: NavigationTab[] = [];

    tabs.push(
      { to: ROUTES.admin.settings, title: 'title.users' },
      { to: ROUTES.admin.config, title: 'title.config' },
    );

    if (RootStore.config.feature.sptStartScreen?.enabled) {
      tabs.push({
        to: ROUTES.admin.startScreenDesigner,
        title: 'startScreenDesigner.title',
        description: 'startScreenDesigner.description',
        isActive: (pathname: string) =>
          pathname.includes(ROUTES.admin.startScreenDesigner),
      });
    }

    if (RootStore.config.feature.banners?.enabled) {
      tabs.push({
        to: ROUTES.admin.banners,
        title: 'banners.title',
        description: 'banners.subtitle',
      });
    }

    return tabs;
  }
}

export default SettingsPage;
